module.exports = __webpack_public_path__ + "img/genre_pop.c7f8f3a2.png";